/* lua.js generated code undefined */
require("clover/panel/component/common/UIGroupButton")

let AuthorizeGuideTipPanel = xClass("AuthorizeGuideTipPanel", BasePanel, function () {
    let __VA_ARG = $slice(arguments, 0)
    // WARN: maybe multi result
    return cc.Node.create()
})

let SHOW_TYPE = {
    tip : 1,
    guide : 2
}
let RES = table(
    "packed/Premission.pack",
    "font/zzgftongxin_40_greenstroke.png",
    "font/zzgftongxin_40_greenstroke.fnt",
)
AuthorizeGuideTipPanel.preloadRes = function (onSuccess, onFail, onCancel, useMask = false) {
    preloadWithLoading(RES, onSuccess, onFail, onCancel, useMask)
}
let _instance = null
AuthorizeGuideTipPanel.getInstance = function () {
    let self = this
    return _instance
}
AuthorizeGuideTipPanel.prototype.ctor = function (data) {
    let self = this
    // super 
    // BasePanel.ctor(self)
    BasePanel.prototype.ctor.call(self);
    _instance = self

    this.data = data;
    this.showType = data.showType;
    this.cb = data.cb;
    this.cancelCb = data.cancelCb;
    self.initUI();
}
AuthorizeGuideTipPanel.prototype.onClose = function (callback, arg, withoutAnim) {
    let self = this
    // BasePanel.onClose(self, callback)
    BasePanel.prototype.onClose.call(self, callback, arg, withoutAnim);

}


AuthorizeGuideTipPanel.prototype.initUI = function () {
    let self = this
    self.mainNode = cc.CSLoader.createNode("cocos/permission_permission.csb")
    self.addChild(self.mainNode);
    this.authorization =  self.mainNode.getChildByName("authorization")
    this.setup = self.mainNode.getChildByName("setup")
    this.authorization.setVisible(false)
    this.setup.setVisible(false)

    if (this.showType == SHOW_TYPE.tip){
        cc.log("提示")
        this.authorization.setVisible(true)
        this.initTipUI()
    }else if (this.showType == SHOW_TYPE.guide){
        cc.log("引导")
        this.setup.setVisible(true)
        this.initGuideUI()
    }
    
    return
    let bg = ccui.Scale9Sprite.createWithSpriteFrameName("commonLib/lib_panel_frame_generalpanel_orange.png", cc.rect(50, 50, 150, 100))
    this.addChild(bg);
    bg.width = 600;
    bg.height = 400;
    // this.textTip = cc.LabelTTF.create("(可领取)", FONT_DEF.microsoftYahei_22_noStroke)
    // bg.addChild(this.textTip)
    // this.textTip.setColor(cc.c3b(255, 0, 0))

    this.btnClose = cc.Sprite.createWithSpriteFrameName("commonLib/lib_panel_btn_close.png")
    bg.addChild(this.btnClose);
    this.btnClose.setPosition(bg.width - 50,bg.height - 50);

    quickBuildBtn(this.btnClose, UIGroupButton, PushBounceAnim, () => {
        if (this.cb){
            this.cb()
        }
        this.onClose();
    }, true);



    this.btnConfirm = ccui.Scale9Sprite.createWithSpriteFrameName("commonLib/lib_btn_green_normal.png", cc.rect(95, 50, 10, 10))
    bg.addChild(this.btnConfirm);

    quickBuildBtn(this.btnConfirm, UIGroupButton, PushBounceAnim, () => {
        if (this.cb) this.cb();
        this.onClose();
    }, true);
    this.btnConfirm.width = 220;
    this.btnConfirm.setPosition(bg.width/2 - 130, this.btnConfirm.height);

    this.btnCancel = ccui.Scale9Sprite.createWithSpriteFrameName("commonLib/lib_btn_orange_normal.png", cc.rect(95, 50, 10, 10))
    bg.addChild(this.btnCancel);
    this.btnCancel.width = 220;
    this.btnCancel.setPosition(bg.width/2 + 130, this.btnConfirm.height);

    quickBuildBtn(this.btnCancel, UIGroupButton, PushBounceAnim, () => {
        this.onClose();
        if (this.cancelCb) this.cancelCb();
    }, true);

}

AuthorizeGuideTipPanel.prototype.initTipUI = function () {
    let rootNode = this.authorization
    let btn_click = rootNode.getChildByName("btn_click")
    quickBuildBtn(btn_click, UIGroupButton, PushBounceAnim, () => {
        this.onClose();
        if (this.cb) this.cb();
    }, true);


    let btn_close = rootNode.getChildByName("close")
    quickBuildBtn(btn_close, UIGroupButton, PushBounceAnim, () => {
        this.onClose();
        if (this.cb) this.cb();
    }, true);
    btn_close.setVisible(false)
    let tip_label = rootNode.getChildByName("label")
    tip_label.setVisible(false)
    // tip_label.height = 50
    let textTip = cc.LabelTTF.create(tip_label.string, FONT_DEF.microsoftYahei_22_noStroke)
    textTip.setDimensions(320, 0)
    textTip.setColor(cc.color(173, 64, 27))
    textTip.setPosition(70,20)
    textTip.setHorizontalAlignment(cc.TEXT_ALIGNMENT_LEFT)
    // textTip.height = textTip.height + 50
    textTip.setLineHeight(40)
    rootNode.addChild(textTip)
}
AuthorizeGuideTipPanel.prototype.initGuideUI = function () {
    let self = this
    let rootNode = this.setup
    let btn_click = rootNode.getChildByName("btn_click")
    quickBuildBtn(btn_click, UIGroupButton, PushBounceAnim, () => {
        this.onClose();
        if (this.cb) this.cb();
    }, true);


    let btn_close = rootNode.getChildByName("close_blue")
    quickBuildBtn(btn_close, UIGroupButton, PushBounceAnim, () => {
        this.onClose();
        if (this.cancelCb) this.cancelCb();
    }, true);


}
module.exports = AuthorizeGuideTipPanel